import styled from 'styled-components'

export const AppFont = styled.div`
  font-family: 'Source Sans Pro', sans-serif;
`

export const Container = styled.div`
  width: 1090px;
  margin: 0 auto;
  @media screen and (max-width: 1200px) {
    width: 90%;
  }
`